// extracted by mini-css-extract-plugin
export var navbarDividedLeft = "q_fQ d_fQ d_bz d_bH d_bJ";
export var navbarDividedRight = "q_fR d_fR d_bz d_bJ";
export var menuDesign6 = "q_qz d_fM d_bz d_dw d_bP d_bJ";
export var menuDesign7 = "q_qB d_fM d_bz d_dw d_bP d_bJ";
export var menuRight = "q_qC d_fM d_bz d_dw d_bP d_bJ";
export var menuLeft = "q_qD d_fM d_bz d_dw d_bP d_bJ";
export var menuCenter = "q_qF d_fN d_fM d_bz d_dw d_bP d_w d_bD d_bJ";
export var menuDivided = "q_m9 d_fN d_fM d_bz d_dw d_bP d_w d_bD";
export var menuDesign5 = "q_nl d_fP d_fM d_bz d_dw d_bP d_bJ";
export var isBurger = "q_qG";
export var navbarItem = "q_nb d_bx";
export var navbarLogoItemWrapper = "q_fY d_fY d_bC d_bP";
export var burgerToggleVisibleOpen = "q_qH d_gd d_by d_Z d_bs";
export var burgerToggleVisible = "q_qJ d_gd d_by d_Z d_bs";
export var burgerToggle = "q_qK d_gd d_by d_Z d_bs d_Z";
export var burgerToggleOpen = "q_qL d_gd d_by d_Z d_bs";
export var burgerInput = "q_qM d_f2 d_w d_H d_by d_cc d_dl d_bd d_0 d_8 d_7 d_4 d_9";
export var burgerIcon = "q_qN d_f3 d_w d_H";
export var burgerLine = "q_qP d_f1";
export var burgerMenuDesign6 = "q_qQ d_f7 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var burgerMenuDesign7 = "q_qR d_f7 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var burgerMenuLeft = "q_qS d_f7 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw d_f7 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var burgerMenuDesign5 = "q_qT d_f8 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var burgerMenuRight = "q_qV d_f8 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var burgerMenuCenter = "q_qW d_f9 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var burgerMenuDivided = "q_qX d_f7 d_f6 d_f4 d_f5 d_0 d_cc d_dm d_bs d_dw";
export var secondary = "q_qY d_bC d_bP";
export var compact = "q_qZ";
export var navDivided = "q_q0";
export var staticBurger = "q_q1";
export var menu = "q_q2";
export var navbarDividedLogo = "q_q3";
export var nav = "q_q4";